export enum SocialMediaEnum {
  INSTAGRAM = "Instagram",
  FACEBOOK = "Facebook",
  YOUTUBE = "YouTube",
  X = "X",
  TIKTOK = "TikTok",
  LINKEDIN = "LinkedIn",
}

export type SocialMediaPlatformKey = keyof typeof SocialMediaEnum;

export enum FollowerRangeEnum {
  "0-999" = "0 - 999",
  "1,000-4,999" = "1.000 - 4.999",
  "5,000-9,999" = "5.000 - 9.999",
  "10,000-49,999" = "10.000 - 49.999",
  "50,000+" = "50.000+",
}
